import { MouseEventHandler } from 'react'
import { Box, MenuItem } from '@mui/material'

import { ButtonApp } from 'presentation/components/elements'
import { getIntoText } from 'presentation/constant/globals'
import { urlRoutes } from 'presentation/routes/config/urlRoutes/urlRoutes'
import { committeeText, representativeText } from 'presentation/constant/texts/header'
import { StyledDivider, StyledLink, StyledMenu, StyledMenuItem } from './index.styled'

type HeaderSignInItemProps = {
  isOpenSignInMenu: boolean
  handleCloseSignInMenu: () => void
  anchorSignInEl: any
  handleClickListSignInItemMenu: MouseEventHandler<HTMLElement>
}

export default function HeaderSignInItem({
  isOpenSignInMenu,
  handleCloseSignInMenu,
  anchorSignInEl,
  handleClickListSignInItemMenu,
}: HeaderSignInItemProps) {
  const urlLoginFrontOffice =
    process.env.REACT_APP_URL_LOGIN_FRONTOFFICE !== undefined
      ? process.env.REACT_APP_URL_LOGIN_FRONTOFFICE
      : ''
  return (
    <ButtonApp onClick={handleClickListSignInItemMenu}>
      {getIntoText}
      <StyledMenu anchorEl={anchorSignInEl} open={isOpenSignInMenu} onClose={handleCloseSignInMenu}>
        <Box
          sx={{
            maxWidth: '150px',
            width: '100%',
            padding: '2px 14px',
          }}
        >
          <StyledMenuItem onClick={() => window.open(urlLoginFrontOffice)}>
            {representativeText.toUpperCase()}
          </StyledMenuItem>
          <Box sx={{ margin: '3px 0' }}>
            <StyledDivider />
          </Box>
          <StyledLink to={urlRoutes.public.auth.login.urlTo}>
            <MenuItem>{committeeText.toUpperCase()}</MenuItem>
          </StyledLink>
        </Box>
      </StyledMenu>
    </ButtonApp>
  )
}
